import { push } from 'react-router-redux'

import {
  CHANGE_VIDEO_PLAYER,
  LOAD_PLAYLISTS_PLAYER,
  LOAD_STATUS_PLAYER,
} from './types'

export const handlePlay = playerType => ({
  type: playerType,
})

export const handlePause = playerType => ({
  type: playerType,
})

export const handleChangePlayer = ({ slugName, indexSection, indexLecture }) => {
  return (dispatch) => {
    dispatch(push(`/course/${slugName}/${indexSection}/${indexLecture}`))
    dispatch({
      type: CHANGE_VIDEO_PLAYER,
      data: {
        slugName,
        indexSection,
        indexLecture,
      },
    })
  }
}

export const handleLoadPlaylists = (playlists) => {
  return {
    type: LOAD_PLAYLISTS_PLAYER,
    data: playlists,
  }
}

export const handleAction = (status, data) => {
  return {
    type: LOAD_STATUS_PLAYER,
    data: {
      status,
      ...data,
    },
  }
}



// WEBPACK FOOTER //
// ./src/actions/player.js